import React, { ReactNode, ReactNodeArray, CSSProperties } from 'react'
import Property from '@episerver/spa-core/Components/Property'
import EpiComponent from '@episerver/spa-core/EpiComponent'
import UpdatePaymentMethodBlockData from '../../../Models/Content/UpdatePaymentMethodBlockData'
import UpdatePaymentMethod from './UpdatePaymentMethod';
import './updatePaymentStyle.scss';
import { isMobile } from "react-device-detect";

export default class UpdatePaymentMethodBlock extends EpiComponent<UpdatePaymentMethodBlockData> {
    public render(): null | ReactNode | ReactNodeArray {
        return (
                <UpdatePaymentMethod cmsData = {this.props.data} context={this.getContext()}/>
        )
    }
}